module.exports = __webpack_public_path__ + "img/messages-icon.ba927194.svg";